export default function AnomalyStarIco({ size }) {
  return (
    <svg
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6ZM8.22426 4.37573C8.45856 4.61005 8.45856 4.98996 8.22426 5.22426L6.01458 7.43394C5.67516 7.77336 5.12484 7.77336 4.78541 7.43394L3.77573 6.42426C3.54142 6.18996 3.54142 5.81004 3.77573 5.57574C4.01005 5.34144 4.38995 5.34144 4.62427 5.57574L5.4 6.35148L7.37574 4.37573C7.61004 4.14142 7.98996 4.14142 8.22426 4.37573Z"
        fill="#0070F2"
      />
    </svg>
  );
}
